import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PunchoutCustomerConfig, PunchoutOrderIntakeHandlerOption } from '../../models/punchout';

// This bypasses the gung request-cache interceptor. Admin reads must always show the latest
// write. See request-cache.service.ts:42 for the header contract.
const NO_CACHE_HEADERS = { maxAge: '-1' };

@Injectable({ providedIn: 'root' })
export class PunchoutConfigAdminService {
  protected http = inject(HttpClient);
  private readonly base = 'json/punchout/configs';

  list(): Observable<PunchoutCustomerConfig[]> {
    return this.http.get<PunchoutCustomerConfig[]>(this.base, { headers: NO_CACHE_HEADERS });
  }

  get(id: string): Observable<PunchoutCustomerConfig> {
    return this.http.get<PunchoutCustomerConfig>(`${this.base}/${encodeURIComponent(id)}`, {
      headers: NO_CACHE_HEADERS
    });
  }

  save(config: PunchoutCustomerConfig): Observable<PunchoutCustomerConfig> {
    return this.http.post<PunchoutCustomerConfig>(this.base, config);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/${encodeURIComponent(id)}`);
  }

  orderIntakeHandlers(): Observable<PunchoutOrderIntakeHandlerOption[]> {
    return this.http.get<PunchoutOrderIntakeHandlerOption[]>(`${this.base}/order-intake-handlers`, {
      headers: NO_CACHE_HEADERS
    });
  }
}
